export default [
  {
    title: 'Dashboard',
    route: 'admin-dashboard',
    icon: 'HomeIcon',
    role: 'admin'
  },
  {
    title: 'Product',
    icon: true,
    role: 'admin,approver',
    children: [
      {
        title: 'List Product',
        route: 'admin-product',
        role: 'admin,approver'
      },
      {
        title: 'Upload Product Tarif',
        route: 'admin-product-tarif',
        role: 'admin'
      },
      {
        title: 'Config Compare Product',
        route: 'admin-compare-product',
        role: 'admin'
      },
      {
        title: 'Time Portofolio',
        route: 'admin-product-time-portofolio',
        role: 'admin'
      },
      {
        title: 'Division',
        route: 'admin-product-division',
        role: 'admin'
      },
      {
        title: 'Business Line',
        route: 'admin-product-business-line',
        role: 'admin'
      },
      {
        title: 'Product Line',
        route: 'admin-product-product-line',
        role: 'admin'
      },
      {
        title: 'Partner',
        route: 'admin-product-partner',
        role: 'admin'
      }
    ],
  },
  {
    title: 'Product Request',
    route: 'admin-product-request',
    role: 'admin'
  },
  // {
  //   title: 'Competitor Comparison',
  //   icon: true,
  //   role: 'admin',
  //   children: [
  //     {
  //       title: 'List Comparison',
  //       route: 'admin-list-comparison',
  //       role: 'admin'
  //     },
  //     {
  //       title: 'Create Comparison',
  //       route: 'pricing-connectivity',
  //       role: 'admin'
  //     },
  //   ]
  // },
  // {
  //   title: 'Product Tree',
  //   route: 'admin-tree',
  //   role: 'admin'
  // },
  {
    title: 'Podcast',
    route: 'admin-podcast',
    role: 'admin'
  },
  {
    title: 'News',
    route: 'admin-news',
    role: 'admin'
  },
  {
    title: 'Nota Dinas',
    route: 'admin-nota-dinas',
    role: 'admin'
  },
  // {
  //   title: 'Zona Tarif Inner',
  //   route: 'admin-zona-tarif-inner',
  //   role: 'admin'
  // },
  {
    title: 'NPS',
    role: 'admin',
    children: [
      {
        title: 'NPS Web',
        icon: 'CircleIcon',
        route: 'admin-nps',
        role: 'admin'
      },
      {
        title: 'NPS Mobile',
        icon: 'CircleIcon',
        route: 'admin-nps-mobile',
        role: 'admin'
      }
    ]
  },
  {
    title: 'PCC',
    route: 'admin-pcc-index',
    role: 'admin'
  },
  // {
  //   title: 'Flip Book',
  //   route: 'admin-flip-book',
  //   role: 'admin'
  // },
  // {
  //   title: 'Contact Us Request',
  //   route: 'admin-contact-us-request',
  //   role: 'admin'
  // },
  {
    title: 'Reservation Request',
    route: 'admin-reservation-request',
    role: 'admin'
  },
  {
    title: 'Settings',
    icon: true,
    role: 'admin',
    children: [
      {
        title: 'Logo',
        icon: 'CircleIcon',
        route: 'admin-settings-logo',
        role: 'admin'
      },
      {
        title: 'Contact Us',
        icon: 'CircleIcon',
        route: 'admin-settings-contacts',
        role: 'admin'
      },
      {
        title: 'Footer',
        icon: 'CircleIcon',
        route: 'admin-settings-footer',
        role: 'admin'
      },
      {
        title: 'Product',
        icon: 'CircleIcon',
        route: 'admin-settings-products',
        role: 'admin'
      },
      {
        title: 'Apps Link',
        icon: 'CircleIcon',
        route: 'admin-settings-app-link',
        role: 'admin'
      },
      {
        title: 'Terms Of Use',
        icon: 'CircleIcon',
        route: 'admin-settings-tos',
        role: 'admin'
      },
      {
        title: 'Ldap Config',
        icon: 'CircleIcon',
        route: 'admin-ldap-conf',
        role: 'admin'
      },
      {
        title: 'App Version',
        icon: 'CircleIcon',
        route: 'app-version-index',
        role: 'admin'
      },
      {
        title: 'Chat',
        icon: 'CircleIcon',
        route: 'admin-settings-chat-index',
        role: 'admin'
      },
    ],
  },
  {
    title: 'Notification Center',
    route: 'admin-notification-center',
    role: 'admin',
  },
  {
    title: 'User',
    role: 'admin',
    children: [
      {
        title: 'User List',
        role: 'admin',
        route: 'admin-users-index',
      },
      {
        title: 'User Log',
        role: 'admin',
        route: 'tracker-index'
      },
    ]
  },
  {
    title: 'Visitor',
    role: 'admin',
    children: [
      {
        title: 'Visitor Web',
        icon: 'CircleIcon',
        route: 'admin-visitor-index',
        role: 'admin'
      },
      {
        title: 'Visitor Mobile',
        icon: 'CircleIcon',
        route: 'admin-mobile-visitor-index',
        role: 'admin'
      }
    ]
  },
]
